<template>
  <!-- <footer class="footer bg-dark pt-4">
      <div class="container py-2">
        <p class="fs-sm text-center text-sm-start mb-4"><span class="text-light opacity-50">&copy; Syndesi One Limited. All rights reserved.</span></p>
      </div>
    </footer> -->
  <!-- Powered by Syndesi -->
  <footer class="footer pt-10 text-center mt-5 pb-4">
    Powered by <a target="_blank" href="https://www.syndesi.network/"><img style="height: 20px; margin-left: 5px;"
        src="/img/logo-light.png" alt="Syndesi"></a>

    <div class="mt-2">
      <small>All rights reserved. Version 2.0.1</small>
    </div>

    <div class="links mt-2">
      <a target="_blank"
        href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/682df97de4a6e87953bf3559__Syndesi%20Platform%20Terms%20-%2021_5_25.pdf">
        <small>Terms & Conditions</small>
      </a>

      <a class="ms-3" target="_blank"
        href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/68760cbc4c58f63d40c37040_Syndesi%20Privacy%20Notice%20(15_07_25).docx.pdf">
        <small>Privacy Policy</small>
      </a>
    </div>
  </footer>
  <!-- / Powered by Syndesi -->
</template>

<script>
export default {
  setup() {

  },
}
</script>


<style></style>
